<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/pixeden-stroke-7-icon@1.2.3/pe-icon-7-stroke/dist/pe-icon-7-stroke.min.css">
<div class="container padding-bottom-3x mb-1" style="padding-left:0px;padding-right:0px; padding-top:0px;">
  <div class="card mb-3">
    <div class="d-flex flex-wrap flex-sm-nowrap justify-content-between py-3 px-2 bg-secondary">
      <div class="text-center py-1 px-2 flex-grow-1">
        <span *ngIf="!selectedService" class="text-medium" style="color:black;">Заявяване на Електронна Услуга</span>
        <span *ngIf="selectedService" class="text-medium" style="color:black;"><b>Услуга:</b> {{selectedService.yri}} {{selectedService.serviceName}}</span>
        <span *ngIf="selectedSProvider" class="text-medium" style="color:black;"> <b> Доставчик:</b> {{selectedSProvider.serviceProvider.serviceProviderName}}</span>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
    <div class="card-body">
      <div class="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
        <div class="step" [ngClass]="isStepCompleted(1)?'completed':''">
          <div class="step-icon-wrap">
            <div class="step-icon"><i class="fa fa-pencil-square-o"></i></div>
          </div>
          <h4 class="step-title">Заявител</h4>
        </div>
        <div class="step" [ngClass]="isStepCompleted(2)?'completed':''">
          <div class="step-icon-wrap">
            <div class="step-icon"><i class="fa fa-gear"></i></div>
          </div>
          <h4 class="step-title">Избор на Услуга</h4>
        </div>
        <div class="step" [ngClass]="isStepCompleted(3)?'completed':''">
          <div class="step-icon-wrap">
            <div class="step-icon"><i class="fa fa-file"></i></div>
          </div>
          <h4 class="step-title">Набор Документи</h4>
        </div>
        <div class="step" [ngClass]="isStepCompleted(4)?'completed':''">
          <div class="step-icon-wrap">
            <div class="step-icon"><i class="fa fa-truck"></i></div>
          </div>
          <h4 class="step-title">Доставчик</h4>
        </div>
        <div class="step" [ngClass]="isStepCompleted(5)?'completed':''">
          <div class="step-icon-wrap">
            <div class="step-icon"><i class="fa fa-info-circle"></i></div>
          </div>
          <h4 class="step-title">Обобщение</h4>
        </div>
        <div class="step" [ngClass]="isStepCompleted(6)?'completed':''">
          <div class="step-icon-wrap">
            <div class="step-icon"><i class="fa fa-credit-card"></i></div>
          </div>
          <h4 class="step-title">Плащане</h4>
        </div>
        <div class="step" [ngClass]="isStepCompleted(7)?'completed':''">
          <div class="step-icon-wrap">
            <div class="step-icon"><i class="fa fa-check"></i></div>
          </div>
          <h4 class="step-title">Резултат</h4>
        </div>
      </div>
      <div class="container">
        <div class="stepper">

          <ng-container *ngIf="!isLoaded">
            <div style="text-align: center;">
              <div class="spinner-grow spinner-grow-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>

              <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>

              <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </ng-container>

          <div class="step" id="step1">
            <h5>Данни на Заявителя</h5>
            <i>Моля попълнете личните данни на заявителя</i>
            <form [formGroup]="personalInfoForm">
              <div class="form-group mt-4">
                <label for="firstName">Име</label>
                <input type="text" formControlName="firstName" id="firstName" class="form-control">
                <div *ngIf="personalInfoForm.controls['firstName'].invalid && (personalInfoForm.controls['firstName'].dirty || personalInfoForm.controls['firstName'].touched)">
                  <span class="text-danger">Името е задължително.</span>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="middleName">Презиме</label>
                <input type="text" formControlName="middleName" id="middleName" class="form-control">
                <div *ngIf="personalInfoForm.controls['middleName'].invalid && (personalInfoForm.controls['middleName'].dirty || personalInfoForm.controls['middleName'].touched)">
                  <span class="text-danger">Презимето е задължително.</span>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="familyName">Фамилия</label>
                <input type="text" formControlName="familyName" id="familyName" class="form-control">
                <div *ngIf="personalInfoForm.controls['familyName'].invalid && (personalInfoForm.controls['familyName'].dirty || personalInfoForm.controls['familyName'].touched)">
                  <span class="text-danger">Фамилията е задължителна.</span>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="egn">ЕГН</label>
                <input type="text" formControlName="egn" id="egn" class="form-control">
                <div *ngIf="personalInfoForm.controls['egn'].invalid && (personalInfoForm.controls['egn'].dirty || personalInfoForm.controls['egn'].touched)">
                  <span class="text-danger">ЕГН-то е задължително.</span>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="address">Адрес</label>
                <input type="text" formControlName="address" id="address" class="form-control">
                <div *ngIf="personalInfoForm.controls['address'].invalid && (personalInfoForm.controls['address'].dirty || personalInfoForm.controls['address'].touched)">
                  <span class="text-danger">Адресът е задължителен.</span>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="phone">Телефон за контакти</label>
                <input type="text" formControlName="phone" id="phone" class="form-control">
                <div *ngIf="personalInfoForm.controls['phone'].invalid && (personalInfoForm.controls['phone'].dirty || personalInfoForm.controls['phone'].touched)">
                  <span class="text-danger">Телефона е задължителен.</span>
                </div>
              </div>
              <div class="form-group mt-4">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="onBehalf" formControlName="onBehalf">
                  <label class="form-check-label" for="onBehalf">
                    Изпращане от Името на заявителя
                  </label>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="email">Електронна Поща</label>
                <input type="text" formControlName="email" id="email" class="form-control">
                <div *ngIf="personalInfoForm.controls['email'].invalid && (personalInfoForm.controls['email'].dirty || personalInfoForm.controls['email'].touched)">
                  <span class="text-danger">Електронната Поща е задължителена.</span>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="responseType">Вид Обратна Връзка</label>
                <div class="payment-wrapper">
                  <select class="form-control" id="responseType" (change)="onResponseTypeChange($event)" [(ngModel)]="selectedResponseType">
                    <option *ngFor="let method of responseTypes" [value]="method.value">
                      {{GetCyrilicRequestType(method.value)}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group mt-4">
                <label for="shippingMethod">Метод за Доставка (опционално)</label>
                <select class="form-control" id="shippingMethod" [(ngModel)]="selectedShippingMethod" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="null">-- Изберете метод за доставка --</option>
                  <option *ngFor="let method of shippingMethods" [ngValue]="method">
                    {{method.name}} - {{method.price}} лв.
                  </option>
                </select>
              </div>
              <div class="form-group mt-4">
                <label for="deliveredDate">Дата на Доставка (опционално)</label>
                <input type="date" class="form-control" id="deliveredDate" [(ngModel)]="deliveredDate" [ngModelOptions]="{standalone: true}">
              </div>
            </form>
          </div>
          <!-- Step 2: Service Selection -->
          <div class="step d-none" id="step2">
            <h5>Избор на Услуга</h5>
            <i>Моля изберете услугата която ще се заявява и попълнете документите</i>
            <div class="form-group mb-5">
              <div style="display: flex; align-items: center;">
                <!-- Search input box -->
                <input type="text" [(ngModel)]="searchQuery" class="form-control" placeholder="Search for a service..." style="flex: 1; margin-right: 10px;">

                <!-- Search button -->
                <button (click)="filterServices()" class="btn btn-primary">Search</button>
              </div>

              <!-- Display filtered services in the table -->
              <table class="table table-hover mt-3" *ngIf="filteredNServices.length">
                <thead>
                  <tr>
                    <th scope="col">УРИ</th>
                    <th scope="col">Service Name</th>
                    <!-- Add other columns as needed -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let service of filteredNServices"
                      [ngClass]="selectedService === service ? 'selected-row' : ''"
                      (click)="selectService(service)">
                    <td>{{service.yri}}</td>
                    <td>{{service.serviceName}}</td>
                    <!-- Add other columns as needed -->
                  </tr>
                </tbody>
              </table>

              <!-- Error message -->
              <div *ngIf="!filteredNServices.length && searchQuery">
                <span class="text-danger">Няма услуги отговарящи на подадените.</span>
              </div>
            </div>


          </div>


          <!-- step 3.5 documents-->
          <div class="step d-none" id="step3">
            <form [formGroup]="serviceForm">
              <!-- real slim shady -->
              <ng-container *ngIf="alldocServices.length >0">
                <div class="alert alert-primary" role="alert">
                  <p>Моля изтеглете необходимите документи за физическо подписване и ги качете в системата</p>
                </div>
                <ul class="flex-row files-content">
                  <ng-container *ngFor="let file of getSortedDocumentServices()">
                    <li class="folder-box d-flex align-items-center files-container">
                      <div style="width: 100%;" [ngClass]="{'isrequired': file.isRequired}" class="d-flex align-items-center files-list rightBorder">
                        <div *ngIf="file.isDownloadable" (click)="downloadDocument(file.documents.path)" class="flex-shrink-0 file-left">
                          <i style="font-size:20px" class="fa fa-cloud-download"></i>
                        </div>
                        <div *ngIf="!file.isDownloadable" class="flex-shrink-0 file-left empty-box" style="background-color:white;">

                        </div>
                        <div class="flex-grow-1 ms-3">
                          <h6 class="files-title">
                            {{ trimAndEllipsize(file.documents.title,30) }}
                            <span style="font-weight: 400;color: green;" *ngIf="isDocumentUploaded(file)">({{getFileNameAndExtension(file)}})</span>
                          </h6>
                          <p class="files-subtitle">{{trimAndEllipsize(file.documents.description,60)}} {{requireSign(file)}}</p>
                        </div>
                        <div class="m-l-20">
                          <app-upload [showUploadMessage]="false" [successIcon]="isDocumentUploaded(file)" (onUploadFinished)="onFileUpload($event,file.documentsIdDocument)"></app-upload>
                        </div>
                      </div>
                    </li>
                  </ng-container>
                </ul>
              </ng-container>


            </form>
          </div>


          <!-- Step 4: select provider -->
          <div class="step d-none" id="step4">
            <h5>Избор на Доставичк</h5>
            <i>Моля изберете доставчика на услуга</i>
            <div style="display: flex; align-items: center; margin-bottom: 15px;">
              <!-- Search input box -->
              <input type="text" [(ngModel)]="searchQuery" class="form-control" placeholder="Search for a service provider..." style="flex: 1; margin-right: 10px;">

              <!-- Search button -->
              <button (click)="filterServiceProviders()" class="btn btn-primary">Search</button>
            </div>
            <div class="step-container">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">Име</th>
                    <th scope="col">Вид Услуга</th>
                    <th scope="col">Име Доставчик</th>
                    <th scope="col">Такса на Доставчика</th>
                    <th scope="col">Банкова сметка на Доставчика</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sProvider of filteredServiceProviders" [ngClass]="!isSelected(sProvider)?'':'selected-cell'" (click)="onUserSelected(sProvider)">
                    <td>{{sProvider.title}}</td>
                    <td>{{sProvider.service.serviceName}}</td>
                    <td>{{sProvider.serviceProvider.serviceProviderName}}</td>
                    <td>{{sProvider.deliverTaxe}}</td>
                    <td>{{sProvider.bankDetails.title}}({{sProvider.bankDetails.iban}})</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>


          <!-- Step 5: Фискална бележка -->
          <div class="step d-none" id="step5">
            <div class="receipt">
              <h3>ИТ Сървиз Еоод</h3>
              <div>
                <div class="recipt-general-info">
                  <div><b style="margin-right:10px">Служител:</b> {{currentUser.firstName}} {{currentUser.fammilyName}}</div>
                  <div><b>Организация:</b> {{currentUser.organization.title}}</div>
                </div>
                <div>
                  <b style="margin-right:20px;margin-bottom:5px">Заявител:</b>{{getRequestorNames()}}
                </div>
                <div>
                  <b style="margin-right:10px">Доставчик:</b>{{getServiceProviderName()}}
                </div>
              </div>
              <hr>
              <div class="services">
                <div class="service-item">
                  <div class="main-prices">
                    <span>
                      {{
selectedService?.serviceName
                      }}
                    </span> <span class="service-price">{{getTotalServiceFee()}} лв.</span>
                  </div>
                  <div class="sub-prices">
                    <span>Такса</span>
                    <span class="service-price">{{selectedSProvider?.deliverTaxe}} лв.</span>
                  </div>
                  <div class="sub-prices">
                    <span>Комисионна</span>
                    <span class="service-price">{{getAgentComission()}} лв.</span>
                  </div>
                </div>

              </div>
              <hr>
              <div class="total" style="flex-direction:unset">
                <span>Общо</span>
                <span class="total-price">{{getTotalServiceFee()}} лв.</span>
              </div>
              <div class="date-time">
                <p>06/10/2023 12:34 PM</p>
              </div>
            </div>
          </div>

          <!-- Step 6: Плащане -->
          <div class="step  d-none" id="step6">

            <!-- dlow-->
            <div class="card-body">
              <div class="d-flex">
                <ul ngbNav
                    #nav3="ngbNav"
                    [activeId]="1"
                    class="nav nav-pills border-tab nav-left col-3"
                    orientation="vertical">
                  <li [ngbNavItem]="2">
                    <a ngbNavLink>ЕПей</a>
                    <ng-template ngbNavContent>
                      <ng-container *ngIf="currentOrganisation.enableEPay">  <app-epay-prof-payment [serviceRequest]="serviceRequest" [amount]="getTotalServiceFee()"></app-epay-prof-payment></ng-container>
                      <ng-container *ngIf="!currentOrganisation.enableEPay">ЕПей не е включен за вашата Организация, моля свържете се с наш.</ng-container>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="3">
                    <a ngbNavLink>Дебитна/Кредитна карта</a>
                    <ng-template ngbNavContent>
                      <div style="min-width:600px !important;">
                        <app-mpost-pay [serviceRequest]="serviceRequest" [deliverService]="selectedSProvider" [amount]="getTotalServiceFee()" (paymentStatus)="handlePaymentStatus($event)" ></app-mpost-pay>
                      </div>
                    </ng-template>
                  </li>
                </ul>
                <div [ngbNavOutlet]="nav3" class=""></div>
              </div>
            </div>
            <!-- flow end-->
          </div>
          <!-- Step 7: success Request -->
          <div class="step d-none" id="step7">
            <div class="text-center">
              <i class="bi bi-check-circle-fill text-success" style="font-size: 5rem;"></i>
            </div>
            <h5 class="text-center mt-4">Успешно заявяване на Услуга</h5>
          </div>
        </div>


      </div>

    </div>
  </div>
  <div class="d-flex flex-wrap flex-md-nowrap justify-content-center justify-content-sm-between align-items-center">
    <div class="text-right text-sm-right" style="text-align:right; width:100%; padding-right:20px;">
      <button class="btn btn-primary" *ngIf="!isHidden()" (click)="prevStep()" style="margin-right:20px;" id="prevBtn">Предишна Стъпка</button>
      <button class="btn btn-primary" *ngIf="!isHidden()" [disabled]="!isEnabled()" (click)="proceedToNextStep()" id="nextBtn">Следваща Стъпка</button>
      <button class="btn btn-primary" *ngIf="showOkButton()" (click)="proceedToNextStep()" id="nextBtn">Затвори</button>
    </div>
  </div>
</div>
